<script lang="ts">
	import ActionButton from './ActionButton.svelte';

	export let title: string;
	export let subtitle: string;
	export let tagline: string;
	export let backgroundImage: string;
</script>

<svelte:head>
	<link rel="preload" as="image" href={backgroundImage} />
</svelte:head>

<div class="slide">
	<div
		class="slide-img parallax-effect"
		style="background: url({backgroundImage}) center center / cover scroll no-repeat;"
	/>
	<div class="hero-text-wrap">
		<div class="hero-text white-color fade-center-text">
			<div class="container">
				<div class="white-color text-center white-color">
					<h1 class="font-700 text-uppercase mb-0">{title}</h1>
					<h3 class="font-200 text-uppercase letter-spacing-25 source-font mt-0">{subtitle}</h3>
					<h5 class="font-100 text-uppercase letter-spacing-5 source-font mt-0">{tagline}</h5>
					<ActionButton id="header-call-to-action" />
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
</style>
